import { logger } from '@tuic/logger';
import { cache } from 'react';

import { Account } from '../../index';

type GetRailInformation = (args: {
  idToken: string;
  bookingCode: string;
}) => Promise<Account.GetProfileMyTripsByBookingCodeRailResponse | null>;

export const getBookingRail: GetRailInformation = async ({
  idToken,
  bookingCode,
}) => {
  const { data, error } = await Account.getProfileMyTripsByBookingCodeRail({
    path: {
      bookingCode: bookingCode,
    },
    auth: idToken,
  });

  if (error) {
    logger.error('Could not fetch rail-data.');
    logger.error(error);

    return null;
  }

  return data ?? null;
};

export const memoizedGetBookingRail: GetRailInformation = cache(getBookingRail);
